import { RequestReason } from "../request-access/sharedTypes";
import SelectableCard from "./SelectableCard";
import Grid from "@mui/material/Unstable_Grid2";

export interface SelectableCardListProps extends React.PropsWithChildren {
  changeHandler: (list: any[]) => void;
  list: RequestReason[];
  setSelectedItems: any;
  selectedItems: RequestReason[];
}

function SelectableCardList({
  changeHandler,
  list,
  setSelectedItems,
  selectedItems,
}: SelectableCardListProps) {
  const handleClick = (clickedReason: RequestReason) => {
    const newSelectedItems = [...selectedItems];
    const index = newSelectedItems.findIndex(
      (el) => el.reasonEnglishKey === clickedReason.reasonEnglishKey
    );
    if (index < 0) {
      newSelectedItems.push(clickedReason);
    } else {
      newSelectedItems.splice(index, 1);
    }
    setSelectedItems(newSelectedItems);
    changeHandler(newSelectedItems);
  };
  return (
    <>
      {list.map((el, index: number) => {
        return (
          <Grid xs={6} sm={4} md={4} key={index}>
            <SelectableCard
              requestReason={el}
              selectedItems={selectedItems}
              handleClick={handleClick}
            ></SelectableCard>
          </Grid>
        );
      })}
    </>
  );
}

export default SelectableCardList;
